module.exports = __webpack_public_path__ + "static/media/venue-occasion.c08c9a9f.jpeg";